import React, { useEffect } from "react";
import { useAuthCurrent } from "hooks/auth/auth_current";
import { useNavigate, useSearchParams } from "react-router-dom";
import { AFTER_LOGIN_ADM_PATH_VALUES } from "constant/auth/adm_auth.constant";

export function useAuthAdmNavigate() {
  const [searchParams] = useSearchParams();
  const authCurrent = useAuthCurrent();
  const navigate = useNavigate();
  useEffect(() => {
    // console.log("authCurrent", authCurrent);
    if (authCurrent && authCurrent.un && authCurrent.un !== "") {
      const pathAfterLogin = searchParams.get("pathAfterLogin");
      let navigatePath = "/admin-dashboard";
      // console.log("pathAfterLogin", pathAfterLogin);
      if (
        pathAfterLogin &&
        AFTER_LOGIN_ADM_PATH_VALUES.includes(pathAfterLogin)
      ) {
        navigatePath += "/" + pathAfterLogin;
      }
      navigate(navigatePath);
    }
  }, [authCurrent]);
}
